<template>
    <cic-popup
        :title="item.periodId ? 'Edit Retention Period' : 'New Retention Period'"
        :saveable="editing"
        @blur="$emit('blur')"
        @input="$emit('input')"
    >
        <div class="item-form">
            <ul>
                <li class="form-label-first">
                    {{ $t('Period name') }}
                </li>
                <li>
                    <cic-textbox
                        id="period_name"
                        :enabled="editing"
                        :value="item.name"
                        :maxlength="256"
                        @input="(val) => updateFieldValue('name', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Duration') }}
                </li>
                <li>
                    <EditDuration
                        id="period_duration"
                        :enabled="editing"
                        :value="item.duration"
                        @input="(val) => updateFieldValue('duration', val)"
                    />
                </li>
            </ul>
        </div>
    </cic-popup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import CicTextbox from '@/components/inputs/CicTextbox';
    import EditDuration from './EditDuration';

    export default {
        name: 'EditRetentionPeriod',
        components: {
            EditDuration,
            CicPopup,
            CicTextbox,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        emits: ['blur', 'input', 'updateFieldValue'],
        data() {
            return {
                editing: false,
            };
        },
        created() {
            this.editing = !this.item.periodId || this.$store.hasRight('EDIT_RETENTION_RULES');
        },
        methods: {
            updateFieldValue(field, val) {
                this.$emit('updateFieldValue', field, val);
            },
        },
    };
</script>
